import swal from "sweetalert";
import { updateRequest } from '../dataApi'

export const anulateRequest = async (request, ref) => {
    const setFinal = await swal({text: "Se procede a anular la solicitud, ¿Desea continuar?", icon: "info", buttons: ["Cancelar", "Continuar"],})
    
    if(!setFinal) return false

    await updateRequest({
        id: request,
        status: 'ANULADO',
        ref,
        delivery: false
    })

    return true
}